import bg from '../assets/bg.png';
import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png'
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.png';
import divinenail from '../assets/divinenail.png';
import salon01 from '../assets/salon01.jpg';
import D from '../assets/D.png';
import divider from '../assets/divider.png';
import spa from '../assets/spa.png';
import map from '../assets/map.png';
import technicians from '../assets/technicians.png';

export default {
  bg,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  overlaybg,
  spoon,
  welcome,
  divinenail,
  salon01,
  divider,
  D,
  spa,
  map,
  technicians,
};
